import { getClient } from '@/api/api-client';
import type { IGetUserDetailsResult, IUserCompanyFunction, IUserCompanyFunctionParams } from '@condo/domain';

export const getUserDetails = async (userUid: string): Promise<IGetUserDetailsResult> => {
    const { data } = await getClient('basecamp').get(`/users/${userUid}`);
    return data;
};

export const deleteUser = async (query: { uid?: string; email?: string }): Promise<void> => {
    await getClient('basecamp').delete(`/users`, { data: query });
};

export const resetUserPassword = async (query: { email?: string; continueUrl?: string; uid?: string }): Promise<void> => {
    await getClient('basecamp').post(`/users/reset-password`, { email: query.email, uid: query.uid, continueUrl: query.continueUrl });
};

export const fetchUserCompanyFunctions = async (): Promise<IUserCompanyFunction[]> => {
    const { data } = await getClient('basecamp').get('/users/company-functions');
    return data.userCompanyFunctions;
};

export const updateUserCompanyFunction = async ({
    userCompanyFunctionId,
    userId,
    contactPersonId,
    companyFunction,
}: IUserCompanyFunctionParams): Promise<IUserCompanyFunction> => {
    const { data } = await getClient('basecamp').post(`/users/${userId}/company-functions`, {
        userCompanyFunctionId,
        contactPersonId,
        companyFunction,
    });
    return data.userCompanyFunction;
};

export const deleteUserCompanyFunction = async (userId: string): Promise<void> => {
    await getClient('basecamp').delete(`/users/${userId}/company-functions`);
};
